import { NgModule } from '@angular/core';
import { FabToggleDirective, FabButtonDirective, FabSpeedDialComponent } from './fabSpeedDial.component';
var Ng2FabSpeedDialModule = /** @class */ (function () {
    function Ng2FabSpeedDialModule() {
    }
    Ng2FabSpeedDialModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [
                        FabToggleDirective,
                        FabButtonDirective,
                        FabSpeedDialComponent
                    ],
                    exports: [
                        FabToggleDirective,
                        FabButtonDirective,
                        FabSpeedDialComponent
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    Ng2FabSpeedDialModule.ctorParameters = function () { return []; };
    return Ng2FabSpeedDialModule;
}());
export { Ng2FabSpeedDialModule };
function Ng2FabSpeedDialModule_tsickle_Closure_declarations() {
    /** @type {?} */
    Ng2FabSpeedDialModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    Ng2FabSpeedDialModule.ctorParameters;
}
//# sourceMappingURL=fabSpeedDial.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-fab-speed-dial/src/fabSpeedDial/fabSpeedDial.module.js
// module id = ./node_modules/ng2-fab-speed-dial/src/fabSpeedDial/fabSpeedDial.module.js
// module chunks = vendor